<template>
  <!--  11-1 医疗机构案件招募列表页面（应聘情况列表）-->
  <div class="main-css">
    <!--  标题-->
    <div class="title-css">{{ $t("projectApplicationDetails") }}</div>
    <div class="main-box">
      <!-- 第一行 案件名-->
      <div class="one-line-box">
        <p class="title-all-css">{{ $t("projectTitle") }}</p>
        <el-input :disabled="true" v-model="jobName"></el-input>
      </div>
      <!-- 第二行 採用担当 採用人数-->
      <div class="two-line-box">
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("recruiter") }}</p>

          <el-input :disabled="true" v-model="principal"></el-input>
        </div>
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("numberOfHires") }}</p>
          <el-input :disabled="true" v-model="recruitNumber"></el-input>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="title-all-css">{{ $t("workContent") }}</p>
          <el-input :disabled="true" v-model="workContent"></el-input>
        </div>
      </div>

      <div class="line-button-box">

        <button class="button-css2" @click="goDetail">
          {{ $t("jobDetail") }}
        </button>
      </div>
      <!--    表格部分-->
      <div class="table">
        <el-table
          @row-click="jump"
          ref="multipleTable"
          :data="tableData"
          style="width: 98%"
          :maxHeight="tableHeight"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"> </el-table-column>
          <!--------------人材番号----------------->
          <el-table-column
            prop="resumeId"
            label="人材番号"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.resumeId }}
            </template>
          </el-table-column>
          <!--------------氏名----------------->
          <el-table-column
            prop="name"
            label="氏名"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span style="margin-left: 10px" @click.stop="jump2(scope.row)">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>

          <!--------------性別----------------->
          <el-table-column label="性別">
            <template slot="header">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ sex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item1, index) in SexData"
                    :key="item1.code"
                    :command="item1"
                    >{{ item1.name }}</el-dropdown-item
                  >
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span style="margin-left: 10px" @click.stop="jump2(scope.row)">{{
                scope.row.sex == 0 ? "男" : "女"
              }}</span>
            </template>
          </el-table-column>
          <!--------------生年月日----------------->
          <el-table-column
            prop="birth"
            label="生年月日"
            width="140"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData3"
                style="width:100%"
                type="date"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd"
                clearable
                :placeholder="$t('registerDayselsect')"
              >
              </el-date-picker>
              <!-- <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              /> -->
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!--------------学歴----------------->
          <el-table-column
            prop="education"
            width="120"
            label="学歴"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.education_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeducation_dictText }}
              </span>
            </template>
          </el-table-column>
          <!--------------専攻----------------->
          <el-table-column
            prop="profession"
            width="120"
            label="専攻"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>
          <!--------------日本語----------------->
          <el-table-column
            prop="japanese"
            label="日本語"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("japaneseVs") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <div v-if="language == 'JP'">
                {{ scope.row.jpjapanese_dictText }}
              </div>
              <div v-else>
                {{ scope.row.japanese_dictText }}
              </div>
            </template>
          </el-table-column>
          <!--------------学校----------------->
          <el-table-column
            prop="school"
            label="学校"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("school") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.school }}
            </template>
          </el-table-column>
          <!--------------応募日----------------->
          <el-table-column
            prop="createTime"
            width="210"
            label="応募日"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("fundingDayPayment") }}</p>
              <el-date-picker
                v-model="searchData8"
                type="datetimerange"
                small
                range-separator="~"
                :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')"
                class="data-timer-picker"
                @blur="dataTimeChangeCreateTime"
                @change="pickerChangeCreateTime"
                format="yyyy-MM-dd HH-mm-ss"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <!--------------状態----------------->
          <el-table-column
            prop="applyStatus"
            label="状態"
            width="140"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-input
                v-model="searchData9"
                size="mini"
                placeholder="Search"
                @input="handleFuzzySelectApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <!-- {{ scope.row.statusName_dictText }} -->
              <div v-if="language == 'JP'">
                {{ scope.row.jpstatusName_dictText }}
              </div>
              <div v-else>
                {{ scope.row.statusName_dictText }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalPage"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fuzzySelectApplyJob, selectApplyJobByJobId } from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalInstitutionCaseRecruitmentList",
  components: {},
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      input1: "", //案件名input
      input2: "", //採用担当input
      input3: "", //採用人数input
      input4: "", //勤務内容input
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      bath3: "", //生日
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      totalPage: 0, //总数
      loading: false, //table loading
      searchDataStart: "",

      jobName: "", //案件名input
      recruitNumber: "", //採用人数input
      workContent: "", //勤務内容input
      infoData: [], //案件信息
      principal: "", //担当
      opPrincipal: "",
      disabled: false, //禁用状态
      principalTableDate: [],
      sexCode: "",
      SexData: [],
      jobId: "",
      language: "",
      createTimeIn: "",
      createTimeOut: "",
      statusName_dictText: "",
      sex: "",
      tableHeight: "" //表格高度
    };
  },

  created() {
    this.language = this.$i18n.locale;
    this.jobId = this.$route.query.jobId;
    this.getQueryResumeByJobId();
    this.sexs();
    this.getTableHeight();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 500; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 260) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },

    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        that.sexs();
        that.handleFuzzySelectApplyJob();
      }
    },
    // 生日
    dataTimeChange() {
      this.bath3 = this.timeJs(this.searchData3);
      this.createTime = this.bath3;
      this.handleFuzzySelectApplyJob();
    },
    pickerChangeFn(value) {
      if (value === null) {
        this.bath3 = "";
        this.handleFuzzySelectApplyJob();
      }
    },
    goDetail(){
  this.$router.push({
          path: "/medicalInstitutionCaseManagementDetails",
          name: "medicalInstitutionCaseManagementDetails",
          query: { jobId: this.jobId }
        });
    },
    sexs() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpsex";
      } else {
        dataItems = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.data, "aesFecInfo561");
            that.SexData = aesFecInfo.data;
            console.log(that.SexData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //15-1 resumeId
    jump(row) {
      console.log("跳转到15-1", row);
      this.$router.push({
        path: "/detailsOfCaseProgressInMedicalInstitutions",
        name: "detailsOfCaseProgressInMedicalInstitutions",
        query: {
          resumeId: row.resumeId,
          applyId: row.applyId,
          jobId: this.jobId
        }
      });
    },
    //11-2 row
    jump2(row) {
      console.log("跳转到11-2");
      this.$router.push({
        path: "/medicalInstitutionTalentInformationViewPublic",
        name: "medicalInstitutionTalentInformationViewPublic",
        params: { row: row }
      });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberCases") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberCases"] - b["numberCases"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberCases"] - a["numberCases"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberViewings"] - b["numberViewings"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberViewings"] - a["numberViewings"]
          );
        }
      }
    },
    //data -time 选择
    dataTimeChangeCreateTime() {
      console.log(this.searchData8);
      this.createTimeOut = this.timeJs(this.searchData8[0]);
      this.createTimeIn = this.timeJs(this.searchData8[1]);
      this.handleFuzzySelectApplyJob();
    },
    pickerChangeCreateTime(value) {
      if (value === null) {
        this.createTimeOut = "";
        this.createTimeIn = "";
      }
      this.handleFuzzySelectApplyJob();
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },

    //复选框
    handleSelectionChange(val) {
      console.log(val);
      console.log("选择了" + val.length + "项数据");
    },
    //下拉框
    handleCommandSex(evt) {
      if (evt == null) {
        this.sexCode = "";
        this.sex = "";
      } else {
        this.sexCode = evt.code;
        this.sex = evt.name;
      }

      this.handleFuzzySelectApplyJob();
    },
    //分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getQueryResumeByJobId();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.getQueryResumeByJobId();
    },

    //案件应聘情况查询接口
    async getQueryResumeByJobId() {
      var DTO = {
        jobId: this.jobId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await selectApplyJobByJobId(DTO);

      if (res.data.code === "A0000") {
        const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
        console.log("--------案件应聘情况查询接口接口数据89889--------");
        console.log(aesFecInfo);
        this.tableData = aesFecInfo.data2;
        this.jobName = aesFecInfo.data1[0].jobName;
        this.principal = aesFecInfo.data1[0].userName;
        this.recruitNumber = aesFecInfo.data1[0].recruitNumber;
        this.workContent = aesFecInfo.data1[0].workContent;
        this.totalPage = aesFecInfo.total2;
      }
      // selectApplyJobByJobId(DTO)
      //   .then(res => {
      //     console.log("--------案件应聘情况查询接口接口数据89889--------");
      //     console.log(aesFecInfo);
      //     if (res.data.code === "A0000") {
      //       const aesFecInfo = JSON.parse(AES.decrypt(res));

      //       this.tableData = aesFecInfo.pageUtils.data;
      //       this.jobName = aesFecInfo.jobBaseInfoVO.jobName;
      //       this.principal = aesFecInfo.jobBaseInfoVO.userName;
      //       this.recruitNumber = aesFecInfo.jobBaseInfoVO.recruitNumber;
      //       this.workContent = aesFecInfo.jobBaseInfoVO.workContent;
      //     }
      //   })
      //   .catch(res => {
      //     console.log("案件应聘情况查询接口异常:", res);
      //   });
    },
    //模糊查询当前教育机构应聘信息的用户
    handleFuzzySelectApplyJob() {
      var fuzzySelectResumeDTO = {
        birth: this.bath3,
        createTimeIn: this.createTimeIn,
        createTimeOut: this.createTimeOut,
        education: this.searchData4,
        japanese: this.searchData6,
        jobId: this.jobId,
        name: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        profession: this.searchData5,
        resumeId: this.searchData1,
        school: this.searchData7,
        sex: this.sexCode,
        applyStatus: this.searchData9
      };
      fuzzySelectApplyJob(fuzzySelectResumeDTO)
        .then(res => {
          console.log(
            "--------模糊查询当前教育机构应聘信息的用户接口数据--------"
          );
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("模糊查询当前教育机构应聘信息的用户接口异常:", res);
        });
    },
    getSex() {
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: "sex"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.SexData = aesFecInfo.data;
            console.log(that.SexData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  /*表格*/
  margin-top: 0px;
  width: 100%;
  /* height: 0; */
  padding: 0 40px 0 80px;
  box-sizing: border-box;
  margin-bottom: 60px;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
}
.search button {
  /*search*/
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  margin-top: 10px;
  /* height: 420px; */
}
.table /deep/ .el-input__inner {
  /*search*/
  border: 1px solid transparent;
  font-family: "Open Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  /*下拉框*/
  width: 60px;
}
.table-img-css {
  border-radius: 50%;
}
.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}
.table /deep/ .el-date-editor {
  width: 210px;
}

.pagination {
  /*分页*/
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  /*分页*/
  float: right;
  display: flex;
}
.rowsPage {
  /*RowsPage*/
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.el-input.is-disabled /deep/ .el-input__inner {
  background-color: rgb(255 255 255 / 50%);
  border-color: rgb(255 255 255 / 50%);
  color: #4a4a49;
  cursor: auto;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.one-line-box {
  width: 640px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 5px;
  position: relative;
}
.one-line-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
}
.two-line-box {
  width: 640px;
  height: 48px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.two-line-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
}
.normal-line-box {
  width: 300px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.title-all-css {
  padding: 0 5px;
  background: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  position: absolute;
  top: -12px;
  left: 10px;
  z-index: 10;
}
.big-line-box {
  height: 79px;
  width: 640px;
  margin: 0 auto;
  margin-top: 15px;
}
.big-box-css {
  height: 79px;
  width: 640px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.big-box-css /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
  color: #09101d;
}
.big-box-css /deep/ .el-input {
  width: 99%;
  height: 42px;
  margin-left: 2px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionCaseRecruitmentList/index.vue